var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { FelaComponent } from '@filou/core';
var ReactMap = require('google-map-react').default;
var defaultCenter = { lat: 59.938043, lng: 30.337157 };
var defaultZoom = 9;
var markerRule = function (_a) {
    var active = _a.active, theme = _a.theme, onHover = _a.onHover;
    return ({
        display: 'block',
        fill: active ? theme.color : theme.dark2,
        // opacity: !onHover || active || $hover ? 1 : 0.8,
        cursor: !!onHover && 'pointer'
    });
};
var Marker = function (_a) {
    var className = _a.className, active = _a.active, onHover = _a.onHover;
    return (React.createElement(FelaComponent, { rule: markerRule, active: active, onHover: onHover, className: className, render: function (_a) {
            var className = _a.className;
            return (React.createElement("svg", { onMouseOver: onHover, className: className, width: 40, height: 40, viewBox: "0 0 1792 1792" },
                React.createElement("path", { d: "M1152 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm256 0q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z" })));
        } }));
};
var googleMapStyle = {
    height: '100%',
    width: '100%',
    '& *': {
        overflow: 'visible'
    }
};
var GoogleMap = /** @class */ (function (_super) {
    __extends(GoogleMap, _super);
    function GoogleMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleMap.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, center = _a.center, zoom = _a.zoom, apiKey = _a.apiKey, options = _a.options, rest = __rest(_a, ["children", "className", "center", "zoom", "apiKey", "options"]);
        return (React.createElement(FelaComponent, { style: googleMapStyle, className: className, render: function (_a) {
                var className = _a.className;
                return (React.createElement("div", { className: className },
                    React.createElement(ReactMap, __assign({ defaultCenter: defaultCenter, center: center, defaultZoom: defaultZoom, zoom: zoom, bootstrapURLKeys: { key: apiKey } }, rest, { options: __assign({ minZoomOverride: true, minZoom: 2 }, (options || {})) }, rest), children)));
            } }));
    };
    GoogleMap.Marker = Marker;
    GoogleMap.defaultProps = {
        center: defaultCenter,
        zoom: defaultZoom,
        apiKey: process.env.GOOGLE_MAPS_KEY
    };
    return GoogleMap;
}(React.Component));
export default GoogleMap;
//# sourceMappingURL=map.js.map